import { SimplifiedStepSection } from '@quicktools/shared-components';
import { useTranslation } from 'react-i18next';
import { IconPlusLarge } from '@picsart/icons';
import { UploadButton } from '@quicktools/shared-components';
import { UploadType } from '@quicktools/shared-components/components/core/UploadArea';
import { IStep } from '@quicktools/shared-components/components/landingPages/SimplifiedStepSection';

import { appConfig } from '../../configs';

export interface IHowToSection {
  onUpload: (files: File[], uploadType: UploadType | string) => void;
  disableUpload: boolean;
}

function HowToSection({ disableUpload, onUpload }: IHowToSection) {
  const { t } = useTranslation();
  const steps: IStep[] = Array.from(Array(3)).map((_, index) => ({
    title: t(`landing.howToSection.steps.${index}.title`),
    description: t(`landing.howToSection.steps.${index}.description`),
  }));

  return (
    <SimplifiedStepSection
      cta={
        <UploadButton
          accept={appConfig.accept}
          multiple
          onChange={onUpload}
          disabled={disableUpload}
        >
          <IconPlusLarge />
          {t('landing.howToSection.cta')}
        </UploadButton>
      }
      title={t('landing.howToSection.title')}
      steps={steps}
    />
  );
}

export default HowToSection;
